<template>
  <div class="pagina ativa" id="paginaComissao">
    <div class="pagina-titulo" style="display:flex;align-items:center;gap:9px;"><Wallet :size="20" /> Minhas Comissoes</div>
    <div class="grid-cards" style="margin-bottom:20px;">
      <div class="card"><div class="card-label">Total Vendas</div><div class="card-valor">{{ resumo.totalVendas }}</div></div>
      <div class="card"><div class="card-label">Comissao Total</div><div class="card-valor">{{ fmtBRL(resumo.comissaoTotal) }}</div></div>
      <div class="card" style="color:green;"><div class="card-label">Recebido</div><div class="card-valor" style="color:green;">{{ fmtBRL(resumo.recebido) }}</div></div>
      <div class="card"><div class="card-label">Em Aberto</div><div class="card-valor" style="color:#e67e22;">{{ fmtBRL(resumo.emAberto) }}</div></div>
    </div>
    <div style="background:white;padding:15px 20px;border-radius:10px;box-shadow:0 2px 8px rgba(0,0,0,0.08);margin-bottom:20px;display:flex;gap:15px;flex-wrap:wrap;align-items:flex-end;">
      <div><label>Cliente</label><input type="text" v-model="filtros.cliente" style="width:180px;" /></div>
      <div><label>Contrato</label><input type="text" v-model="filtros.contrato" style="width:150px;" /></div>
      <div><label>De</label><input type="date" v-model="filtros.dataInicio" style="width:155px;" /></div>
      <div><label>Ate</label><input type="date" v-model="filtros.dataFim" style="width:155px;" /></div>
      <div v-if="ehAdmin"><label>Vendedor</label><select v-model="filtros.vendedor" style="width:180px;"><option value="">Todos</option><option v-for="v in vendedoresUnicos" :key="v" :value="v">{{ v }}</option></select></div>
      <div><label>Situacao</label><select v-model="filtros.situacao" style="width:150px;"><option value="">Todas</option><option value="aberto">Em Aberto</option><option value="recebido">Recebidas</option></select></div>
      <div><button @click="limparFiltros" style="margin-top:0;padding:10px 18px;font-size:13px;background:#888;">Limpar</button></div>
    </div>
    <p v-if="carregando" style="text-align:center;color:#888;">Carregando...</p>
    <div v-else-if="vendasComParcelasVisiveis.length === 0" style="text-align:center;color:#888;">Nenhuma venda encontrada.</div>
    <div v-for="v in vendasComParcelasVisiveis" :key="v.contrato + v.cota" class="card" style="text-align:left;margin-bottom:15px;">
      <div style="display:flex;justify-content:space-between;flex-wrap:wrap;gap:8px;margin-bottom:10px;">
        <div>
          <strong style="color:#4a5c2f;">{{ v.cliente }}</strong>
          <span style="color:#888;font-size:12px;"> — {{ v.dataAlocacao || v.dataVenda }} · Grupo {{ v.grupo }} · Cota {{ v.cota }}<span v-if="ehAdmin"> · {{ v.vendedor }}</span> · {{ v.bem }} - {{ v.tabela }}</span>
          <span v-if="v.status === 'Cancelada'" style="display:inline-flex;align-items:center;gap:3px;background:#c0392b;color:white;padding:1px 6px;border-radius:8px;font-size:10px;margin-left:6px;"><X :size="10" /> CANCELADA</span>
          <span v-else-if="v.status === 'Estornada'" style="display:inline-flex;align-items:center;gap:3px;background:#8e44ad;color:white;padding:1px 6px;border-radius:8px;font-size:10px;margin-left:6px;"><TriangleAlert :size="10" /> ESTORNADA</span>
          <span v-else-if="v.status === 'Transferida'" style="background:#f39c12;color:white;padding:1px 6px;border-radius:8px;font-size:10px;margin-left:6px;">Transf.<span v-if="v.novoTitular"> p/ {{ v.novoTitular }}</span></span>
        </div>
        <div style="font-weight:bold;color:#4a5c2f;">{{ fmtBRL(v.valor) }} <span style="font-size:11px;color:#888;font-weight:normal;">| Total: {{ fmtBRL(v.comissaoTotal) }}</span></div>
      </div>
      <div style="overflow-x:auto;">
        <table class="tabela-dash">
          <thead><tr><th>Parcela</th><th>%</th><th>Bruto</th><th>Imposto</th><th>Liquido</th><th>Situacao</th></tr></thead>
          <tbody>
            <tr v-for="p in parcelasVisiveis(v)" :key="p.numero">
              <td style="padding:6px 10px;">Parcela {{ p.numero }}</td>
              <td style="padding:6px 10px;">{{ p.percentual }}</td>
              <td style="padding:6px 10px;" :style="{ textDecoration: estaBloqueada(v, p) ? 'line-through' : 'none' }">{{ fmtBRL(p.valorBruto) }}</td>
              <td style="padding:6px 10px;color:#c0392b;">{{ estaBloqueada(v, p) ? '--' : '-' + fmtBRL(p.valorBruto - p.valorLiquido) }}</td>
              <td style="padding:6px 10px;" :style="{ textDecoration: estaBloqueada(v, p) ? 'line-through' : 'none' }">{{ fmtBRL(p.valorLiquido) }}</td>
              <td style="padding:6px 10px;">
                <span v-if="estaBloqueada(v, p)" style="display:inline-flex;align-items:center;gap:4px;color:#c0392b;font-size:12px;"><Ban :size="13" /> Bloqueada</span>
                <button v-else @click="toggleParcela(v, p)" :style="{ padding: '3px 10px', fontSize: '11px', background: recebidaChave(v, p) ? '#27ae60' : '#e67e22', border: 'none', color: 'white', borderRadius: '4px', cursor: 'pointer', marginTop: 0 }">
                  {{ recebidaChave(v, p) ? 'Recebida' : 'Pendente' }}
                </button>
              </td>
            </tr>
            <tr v-if="v.estorno && v.estorno.isento">
              <td colspan="6" style="padding:6px 10px;color:#27ae60;font-size:11px;">Sem estorno (prazo mínimo superado)</td>
            </tr>
            <tr v-else-if="v.estorno && !v.estorno.semEstorno" style="background:#fff0f0;">
              <td style="display:flex;align-items:center;gap:4px;padding:8px 10px;color:#8e44ad;font-weight:bold;"><TriangleAlert :size="12" /> Estorno</td>
              <td style="padding:8px 10px;color:#8e44ad;">{{ v.estorno.percentual }}</td>
              <td style="padding:8px 10px;color:#8e44ad;">-{{ fmtBRL(v.estorno.valorBruto) }}</td>
              <td style="padding:8px 10px;color:#27ae60;">Isento</td>
              <td style="padding:8px 10px;color:#c0392b;font-weight:bold;">-{{ fmtBRL(Math.abs(v.estorno.valorLiquido)) }}</td>
              <td style="padding:8px 10px;font-size:11px;color:#888;">{{ v.estorno.regra }}</td>
            </tr>
            <tr v-else-if="v.estorno && v.estorno.semEstorno && (v.status === 'Cancelada' || v.status === 'Estornada')">
              <td colspan="6" style="padding:6px 10px;color:#aaa;font-size:11px;">Sem estorno - tabela nao preve devolucao</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost, getSession } from '../api'
import { Wallet, X, TriangleAlert, Ban } from 'lucide-vue-next'

export default {
  name: 'PaginaComissao',
  components: { Wallet, X, TriangleAlert, Ban },
  data() {
    return {
      vendas: [],
      parcelasStatus: {},
      carregando: true,
      filtros: { cliente: '', contrato: '', vendedor: '', situacao: '', dataInicio: '', dataFim: '' }
    }
  },
  computed: {
    ehAdmin() { return getSession().perfil === 'admin' },
    vendedoresUnicos() {
      const s = new Set(this.vendas.map(v => v.vendedor).filter(Boolean))
      return Array.from(s).sort()
    },
    vendasFiltradas() {
      let d = this.vendas.filter(v => !v.isFilha)
      if (!this.ehAdmin) {
        const nome = getSession().nome
        d = d.filter(v => v.vendedor === nome)
      } else if (this.filtros.vendedor) {
        d = d.filter(v => v.vendedor === this.filtros.vendedor)
      }
      if (this.filtros.cliente) d = d.filter(v => (v.cliente || '').toLowerCase().indexOf(this.filtros.cliente.toLowerCase()) > -1)
      if (this.filtros.contrato) d = d.filter(v => (v.contrato || '').indexOf(this.filtros.contrato) > -1)
      if (this.filtros.dataInicio) d = d.filter(v => (v.dataVenda || '') >= this.filtros.dataInicio)
      if (this.filtros.dataFim) d = d.filter(v => (v.dataVenda || '') <= this.filtros.dataFim)
      return d
    },
    vendasComParcelasVisiveis() {
      if (!this.filtros.situacao) return this.vendasFiltradas
      return this.vendasFiltradas.filter(v => this.parcelasVisiveis(v).length > 0)
    },
    resumo() {
      const d = this.vendasFiltradas
      let totalVendas = 0, comissaoTotal = 0, recebido = 0, emAberto = 0
      d.forEach(v => {
        if (!v.isFilha) totalVendas++
        v.parcelas.forEach(p => {
          if (this.estaBloqueada(v, p)) return
          comissaoTotal += p.valorLiquido
          if (this.recebidaChave(v, p)) recebido += p.valorLiquido
          else emAberto += p.valorLiquido
        })
        if (v.estorno && !v.estorno.semEstorno) {
          comissaoTotal += v.estorno.valorLiquido
          emAberto += v.estorno.valorLiquido
        }
      })
      return { totalVendas, comissaoTotal, recebido, emAberto }
    }
  },
  created() {
    this.carregar()
  },
  methods: {
    fmtBRL(v) {
      return 'R$ ' + (parseFloat(v) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    limparFiltros() {
      this.filtros = { cliente: '', contrato: '', vendedor: '', situacao: '', dataInicio: '', dataFim: '' }
    },
    parcelasVisiveis(v) {
      if (!this.filtros.situacao) return v.parcelas
      return v.parcelas.filter(p => {
        if (this.estaBloqueada(v, p)) return false
        const recebida = this.recebidaChave(v, p)
        return this.filtros.situacao === 'recebido' ? recebida : !recebida
      })
    },
    chaveParcela(v, p) {
      return v.vendedor + '_' + v.contrato + '_' + p.numero
    },
    recebidaChave(v, p) {
      return !!this.parcelasStatus[this.chaveParcela(v, p)]
    },
    estaBloqueada(v, p) {
      return p.bloqueada && !this.recebidaChave(v, p)
    },
    async carregar() {
      this.carregando = true
      const [rv, rp] = await Promise.all([apiGet('vendas/com-calculo'), apiGet('parcelas-status/listar')])
      if (rv.sucesso) this.vendas = rv.vendas
      if (rp.sucesso) this.parcelasStatus = rp.parcelas
      this.carregando = false
    },
    async toggleParcela(v, p) {
      const chave = this.chaveParcela(v, p)
      const novoValor = !this.recebidaChave(v, p)
      const r = await apiPost('parcelas-status/marcar', { chave, recebido: novoValor })
      if (r.sucesso) {
        this.parcelasStatus = { ...this.parcelasStatus, [chave]: novoValor }
      }
    }
  }
}
</script>
